var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.75 49.5C29.0992 49.5 32.625 45.9742 32.625 41.625C32.625 37.2758 29.0992 33.75 24.75 33.75C20.4008 33.75 16.875 37.2758 16.875 41.625C16.875 45.9742 20.4008 49.5 24.75 49.5Z",
    stroke: "#3FB483",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 65.25C11.25 57.7942 17.2942 51.75 24.75 51.75C32.2058 51.75 38.25 57.7942 38.25 65.25H11.25Z",
    stroke: "#3FB483",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 15.75H6.75C4.26472 15.75 2.25 17.7647 2.25 20.25V60.75C2.25 63.2353 4.26472 65.25 6.75 65.25H65.25C67.7353 65.25 69.75 63.2353 69.75 60.75V20.25C69.75 17.7647 67.7353 15.75 65.25 15.75H42.75",
    stroke: "#1F1F1F",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.75 13.5C42.75 9.77208 39.7279 6.75 36 6.75C32.2721 6.75 29.25 9.77208 29.25 13.5V22.5C29.25 23.0967 29.4871 23.669 29.909 24.091C30.331 24.5129 30.9033 24.75 31.5 24.75H40.5C41.7426 24.75 42.75 23.7426 42.75 22.5V13.5Z",
    stroke: "#1F1F1F",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 38.25H56.25",
    stroke: "#1F1F1F",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 47.25H60.75",
    stroke: "#1F1F1F",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdIcon);
export default __webpack_public_path__ + "static/media/id-icon.7e0e7e1f03b37ee29990de78e0b7fc12.svg";
export { ForwardRef as ReactComponent };